var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab",class:[
    {
      disabled: _vm.disabled,
      active: _vm.isActive,
      'no-active-state-on-mobile': _vm.noActiveStateOnMobile
    }
  ],attrs:{"title":_vm.showTitle ? _vm.computedTitle : '',"tabindex":_vm.tabAble ? 0 : -1},on:{"click":_vm.handleClick}},[(_vm.icon.name)?_c('aha-svg',{staticClass:"mr-3 flex-shrink-0",attrs:{"size":"md","name":_vm.icon.name,"width":_vm.icon.width || 20,"height":_vm.icon.height || 20,"viewBox":_vm.icon.viewBox,"maintainColor":_vm.icon.maintainColor}}):_vm._e(),_c('span',{staticClass:"tab-label"},[_vm._v(_vm._s(_vm.computedTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }